import React, {useEffect, useState} from "react"
import {useAuth0} from '@auth0/auth0-react';
import {Link} from "react-router-dom";
import {
    Typography,
    Card,
    Button,
    Table,
    Tag,
    Avatar,
    Tooltip, Select, Form
} from 'antd';
import fetchApi from "../helper/fetchApi";
import {Input} from 'antd';
import {redirect} from "react-router-dom";


export default function JobDashboard() {
    const {user, isLoading, getAccessTokenSilently} = useAuth0();
    const [files, setFiles] = useState([])

    useEffect(() => {
        (async () => {
            let files = await fetchApi('files/getList', getAccessTokenSilently);
            files = files.map((file) => {
                return {value: file.name, label: file.name}
            })
            if (files !== null) {
                setFiles(files);
            }
        })()
    }, [])


    async function onFinish(values) {
        let data = {
            ...values,
            initiator: user.name,
        }
        console.log(data);
        let result = await fetchApi('imports/new', getAccessTokenSilently, 'post', data);
        window.location = "/detail/" + result.importId;
    }

    function onFinishFailed(errorInfo) {
        console.log('Failed:', errorInfo);
    }

    return (
        <Card
            title={'New Job'}
        >
            <Form
                name="basic"
                labelCol={{span: 8}}
                wrapperCol={{span: 16}}
                style={{maxWidth: 600}}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
            >

                <Form.Item
                    label="Import Name"
                    name="name"
                    rules={[{required: true, message: 'Please input'}]}
                >
                    <Input/>
                </Form.Item>
                <Form.Item
                    label="Import File"
                    name="file"
                    rules={[{required: true, message: 'Please input'}]}
                >
                    <Select
                        id={'file'}
                        options={files}
                        style={{width: '100%'}}
                    />
                </Form.Item>
                <Form.Item
                    label="Import Type"
                    name="type"
                    rules={[{required: true, message: 'Please input'}]}
                >
                    <Select
                        id={'type'}
                        options={[
                            {value: 'products', label: 'Products'},
                            {value: 'productsWithoutMedia', label: 'Products without Media'},
                            {value: 'prices', label: 'Price Update'},
                            {value: 'categories', label: 'Categories'},
                            {value: 'deleteProducts', label: '[WARNING} Delete Products'},
                        ]}
                        style={{width: '100%'}}
                    />
                </Form.Item>
                <Form.Item>
                    <Button type="primary" htmlType="submit">
                        Submit
                    </Button>
                </Form.Item>
            </Form>
        </Card>

    );
}